//Custo css import
import './style.css'
import Form from 'react-bootstrap/Form';

//React import
import { useState, useCallback, useEffect } from 'react';
import { AiOutlineUpload } from 'react-icons/ai';

//Widgets import
//Classes
import ModalBtn from '../../molecules/modalButton/view';
import ButtonLoading from '../../atoms/buttonLoading/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import * as XLSX from 'xlsx';
import { getTaxes } from '../../../usecases/taxes-usecase';
import { uploadProductInventory } from '../../../usecases/products-usecase';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import ButtonAction from '../../atoms/buttonAction/view';
import ButtonBasic from '../../atoms/buttonBasic/view';
import { DropzoneArea } from "mui-file-dropzone";
import DynamicProgressModal from '../DynamicProgressModal/view';

function LoadProductsFromFile(props) {

    const [files, setFile] = useState(undefined);
    const [excelData, setExcelData] = useState([]);
    const [tableData, setTableData] = useState([]);

    const [currentStep, setCurrentStep] = useState(0);
    const [taxes, setTaxes] = useState([]);

    const fetchTaxes = useCallback(() => {
        getTaxes(1, 1000).then((res) => {
            const rawList = Array.isArray(res?.data)
                ? res.data
                : (Array.isArray(res?.data?.data) ? res.data.data : []);
            const taxList = rawList.filter(t => t && t.tax_type === 1);
            setTaxes(taxList);
        }).catch((err) => {
            console.error("Error loading taxes", err);
            setTaxes([]);
        });
    }, []);

    useEffect(() => {
        fetchTaxes();
    }, [fetchTaxes]);

    const steps = [
        {
            title: 'Cargar factura en formato Excel',
            component: () => (
                <>
                    <a href="/carga_pos.xlsx"  >Descarga la plantilla</a>
                    <DropzoneArea
                        acceptedFiles={[".xlsx"]}
                        filesLimit={1}
                        onDrop={(acceptedFiles) => handleFile(acceptedFiles)}
                        onDelete={() => handleFile(null)}
                        showFileNames={true}
                        dropzoneText="Arrastra o haz click para subir un archivo Excel"
                    /> 
                </>
            ),
        },
        {
            title: '',
            component: () => (
                <>                    
                    <hr></hr>
                    
                    {excelData.length > 0 && (
                        <ButtonBasic style={{marginTop:"30px", marginBottom:"30px"}} type="button" onClick={handleAddRow}> Agregar producto <AiOutlinePlus /></ButtonBasic>
                    )}
                    <br></br>
                    <div className='render-section'>
                        {
                            renderTable()
                        }
                    </div>
                    <br></br>
                    <ButtonLoading onClick={handleUpload} >
                        Cargar Productos
                    </ButtonLoading>
                </>
            ),
        }
    ]

    function handleOpen() {
        fetchTaxes();
    }

    function handleFinish() {
        dispatchCustomEvent("modal-close", null)
        setCurrentStep(0);
    }

    const handleFile = (acceptedFiles) => {
        setFile(acceptedFiles);
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                if (json.length > 0) {
                    const header = json[0];
                    const taxList = Array.isArray(taxes) ? taxes : [];

                    const body = json.slice(1).map(row =>
                        header.map((title, index) => {
                            let value = row[index] !== undefined ? row[index] : '';
                            if (title === 'taxes_value') {
                                if (value === '' || value === undefined || value === null) {
                                    value = 'select';
                                } else if (taxList.length > 0) {
                                    const cleanStr = String(value).trim().replace('%', '');
                                    const numVal = Number(cleanStr);
                                    const matchedTax = taxList.find(t => 
                                        String(t.id) === String(value) || 
                                        Number(t.value) === numVal || 
                                        (!isNaN(numVal) && numVal > 0 && Math.abs(Number(t.value) - numVal / 100) < 0.001) ||
                                        (cleanStr.toLowerCase() === 'excluido' && Number(t.value) === 0) ||
                                        (cleanStr.toLowerCase() === 'exento' && Number(t.value) === 0)
                                    );
                                    if (matchedTax) {
                                        value = matchedTax.id;
                                    }
                                }
                            }
                            return { value, isEdited: false };
                        })
                    );
                    setExcelData(json);
                    setTableData(body);
                    setCurrentStep(1); // Advance to the next step
                }
            };
            reader.readAsArrayBuffer(file);
        } else {
            setExcelData([]);
            setTableData([]);
            setCurrentStep(0); // Reset to the first step if no file
        }
    };


    const handleTableCellChange = useCallback((rowIndex, cellIndex, value) => {
        setTableData(prevTableData => {
            const newTableData = [...prevTableData];
            newTableData[rowIndex] = [...newTableData[rowIndex]];
            newTableData[rowIndex][cellIndex] = { value, isEdited: true };
            return newTableData;
        });
    }, []);

    const handleAddRow = () => {
        setTableData(prevTableData => {
            const newRow = excelData[0].map((headerTitle) => {
                let defaultValue = '';
                if (headerTitle === 'taxes_value') {
                    defaultValue = 'select';
                }
                return { value: defaultValue, isEdited: false };
            });
            return [...prevTableData, newRow];
        });
    };

    const handleDeleteRow = (rowIndex) => {
        setTableData(prevTableData => {
            const newTableData = [...prevTableData];
            newTableData.splice(rowIndex, 1);
            return newTableData;
        });
    };

    const renderTable = () => {
        if (excelData.length === 0) {
            return <p>No data to display</p>;
        }

        const header = excelData[0];
        const body = tableData;
        const taxesColumnIndex = header.findIndex(title => title === 'taxes_value');

        return (
            <div>
                <table style={{ borderCollapse: 'collapse', width: '100%', maxHeight: "60vh" }}>
                    <thead style={{ maxWidth: "98.5%" }}>
                        <tr>
                            <th key={0} style={{ border: 'none', width:"70px", padding: '8px', textAlign: 'left', backgroundColor: 'white', color:"white" }}>
                                Action
                            </th>
                            {header.map((title, index) => (
                                <th key={index} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}>
                                    {title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody style={{ maxHeight: "40vh" }}>
                        {body.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td style={{width:"70px"}}>
                                    <ButtonAction type="button" onClick={() => handleDeleteRow(rowIndex)}><AiOutlineMinus /></ButtonAction>
                                </td>
                                {row.map((cell, cellIndex) => (
                                    <td key={cellIndex} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>
                                        {cellIndex === taxesColumnIndex ? (
                                            <select
                                                value={cell.value}
                                                style={{ width: '100%', boxSizing: 'border-box', border: "none" }}
                                                 onChange={(e) => handleTableCellChange(rowIndex, cellIndex, e.target.value)}
                                             >
                                                <option value="select">Select</option>
                                                 {Array.isArray(taxes) && taxes.map(tax => (
                                                     <option key={tax.id} value={tax.id}>{tax.name}</option>
                                                 ))}
                                             </select>
                                        ) : (
                                            <input
                                                type="text"
                                                value={cell.value}
                                                style={{ width: '100%', boxSizing: 'border-box', border: "none" }}
                                                onChange={(e) => handleTableCellChange(rowIndex, cellIndex, e.target.value)}
                                            />
                                        )}
                                    </td>
                                ))}

                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        );
    };

    const handleUpload = async () => {
        const header = excelData[0];
        const newData = tableData.map(row => {
            const obj = {};
            row.forEach((cell, index) => {
                obj[header[index]] = cell.value;
            });
            return obj;
        });

        // Check for invalid tax values
        const taxList = Array.isArray(taxes) ? taxes : [];
        const invalidTaxes = tableData.map(row => {
            const taxesColumnIndex = header.findIndex(title => title === 'taxes_value');
            const taxValue = row[taxesColumnIndex]?.value;
            if (taxValue === 'select' || !taxValue) return null;
            const tax = taxList.find(tax => String(tax.id) === String(taxValue));
            return tax ? null : taxValue;
        }).filter(taxValue => taxValue !== null);

        if (invalidTaxes.length > 0) {
            invalidTaxes.forEach(taxValue => {
                dispatchCustomEvent("popup", { message: `No se encontró un impuesto con el id ${taxValue}. Por favor, créelo.`, type: "error" });
                dispatchCustomEvent("loading-btn", null);
            })
        }

        const dataToUpload = newData.filter(item => item.taxes_value !== 'select');

        uploadProductInventory("", "", dataToUpload)
            .then((response) => {
                dispatchCustomEvent("reload-stock", {});
                dispatchCustomEvent("loading-btn");
                const validSkus = Array.isArray(response) ? response.map(item => item.sku) : [];
                const errorMessages = Array.isArray(response) ? response.filter(item => item.error).map(item => item.error) : [];

                if (errorMessages.length > 5) {
                    errorMessages.slice(0, 5).forEach(message => {
                        dispatchCustomEvent("popup", { message: message, type: "error" });
                    });
                } else {
                    errorMessages.forEach(message => {
                        dispatchCustomEvent("popup", { message: message, type: "error" });
                    });
                }

                setTableData(prevTableData => {
                    return prevTableData.filter(row => {
                        const sku = row.find((cell, index) => header[index] === 'sku')?.value;
                        return validSkus.includes(sku);
                    });
                });
            })
            .catch((err) => {
                dispatchCustomEvent("loading-btn");
            });
    };

    return (
        <ModalBtn
            id="loadStockFromFile"
            icon={<AiOutlineUpload></AiOutlineUpload>}
            title="Cargar"
            width="90vw"
            onClick={handleOpen}
        >
            <DynamicProgressModal 
                currentStepIndex={currentStep} // Pass current step index
                onStepChange={setCurrentStep} // Pass handler to update step
                steps={steps} 
                onFinish={() => { handleFinish() }}
            /> 
        </ModalBtn>
    )
}

export default LoadProductsFromFile
